/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-15 18:30 VN — WEB-20261015-suzitee-kl-teaser-lift
   Đã làm: đo chiều cao thanh nút dính đáy (mobile) bằng ResizeObserver trên đúng các node thanh, ghi --sz-sticky-h + class sz-kl-lift lên <html>
   để CSS nâng teaser Klaviyo. Không MutationObserver, không đo layout liên tục (chỉ khi thanh đổi kích thước/ẩn-hiện, trong rAF). */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  var SEL = '.btn-preview-fixed, .sticky-checkout-section, .sticky-add-to-cart, #sticky-atc';
  var root = document.documentElement, els = [], ro = null, last = -1, raf = 0, started = false;

  function apply(h) {
    if (h === last) return;
    last = h;
    root.style.setProperty('--sz-sticky-h', h + 'px');
    root.classList.toggle('sz-kl-lift', h > 0);
  }
  function measure() {
    raf = 0;
    var h = 0, ih = window.innerHeight;
    for (var i = 0; i < els.length; i++) {
      var cs = getComputedStyle(els[i]);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') continue;
      var r = els[i].getBoundingClientRect();
      if (r.height > 0 && r.bottom >= ih - 4) h = Math.max(h, Math.round(r.height));
    }
    apply(h);
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(measure); }
  function scan() {
    var found = document.querySelectorAll(SEL), added = false;
    for (var i = 0; i < found.length; i++) {
      if (els.indexOf(found[i]) === -1) { els.push(found[i]); ro.observe(found[i]); added = true; }
    }
    if (added) schedule();
    return els.length > 0;
  }
  function start() {
    if (started || !mq.matches || typeof ResizeObserver === 'undefined') return;
    started = true;
    try {
      ro = new ResizeObserver(schedule);
      var delays = [0, 400, 1000, 2500, 5000, 9000, 15000], k = 0;
      (function tick() {
        if (scan() || k >= delays.length) return;
        setTimeout(tick, delays[k++]);
      })();
      window.addEventListener('load', scan);
    } catch (e) {}
  }
  start();
  if (mq.addEventListener) mq.addEventListener('change', start);
})();
